
  jQuery(document).ready(function(){
        //$('.announcement-bar.color-background-2 .page-width').append('<i class="fa-regular fa-phone"></i>');
  //jQuery('<i class="fa-regular fa-star"></i>').insertAfter('.announcement-bar.color-background-2 .page-width p');
    jQuery('.announcement-bar.color-background-2 .page-width p').append(' <a href="#"><i class="fa-brands fa-instagram"></i> </a> <a href="#"><i class="fa-brands fa-facebook-f"></i> </a> <a href="#"><i class="fa-brands fa-whatsapp"></i></a>');
});
